import React from "react";
import { LocalMessageAttachment } from "@knowt/syncing/types";
export enum ChatAgent {
    USER = "user",
    BOT = "bot",
}

export type ChatMessage = {
    type: ChatAgent;
    text: string;
    disableFeedback?: boolean;
    prompt?: string;
    quote?: string;
    flashcards?: { term: string; definition: string }[];
    attachments?: LocalMessageAttachment[];
};

export type ChatSuggestionOpt = {
    id?: string;
    label: string | React.ReactNode;
    icon?: React.ReactNode;
    disabled?: boolean;
    style?: React.CSSProperties;
    onClick?: ((e: React.MouseEvent) => any | Promise<any>) | (() => Promise<any> | any);
};

export enum ChatFlowState {
    DEFAULT_ACTION,
    SELECTED_TEXT_ACTIONS,
    DECIDE_RESPONSE_ACTION,
}
